module.exports = __webpack_public_path__ + "assets/img/8.abed2ae6.png";